import React from "react";
import useController from "./controller";
import ChangeEmail from "../../components/ChangeEmail";
import { useTranslation } from "../../locales";

interface Props {
  onCancel: () => void;
}

function ConfirmEmail({ onCancel }: Props) {
  const { onSendEmail, email, onSetCancel } = useController(onCancel);
  const { t } = useTranslation();

  return (
    <ChangeEmail onCancel={onSetCancel} sendEmail={onSendEmail} defaultEmail={email ?? ""} title={t("Confirm email")} />
  );
}

export default ConfirmEmail;
